import React, {useEffect} from "react";
import TableContainer from "@mui/material/TableContainer";
import Paper from "@mui/material/Paper";
import Table from "@mui/material/Table";
import TableHead from "@mui/material/TableHead";
import TableRow from "@mui/material/TableRow";
import TableCell from "@mui/material/TableCell";
import TableBody from "@mui/material/TableBody";
import Box from "@mui/material/Box";
import {Typography} from "@mui/material";
import PropTypes from "prop-types";
import Tabs from "@mui/material/Tabs";
import Tab from "@mui/material/Tab";
import {API_SPEC} from "../spec/apiSpec";
import {useApi} from "../hooks/api-hook";
import {useSelector} from "react-redux";
import {columns} from './collection/definition';
import {Link} from "react-router-dom";
import PaginatedComponentInternalState from "./hoc/PaginatedComponentInternalState";
import BuyEasyCart from "./cart/BuyEasyCart";

function offersSpec({cardId, page, size, offerTypeTab}) {
    return !!cardId
        ? API_SPEC.OFFERS({cardId, page, size, offerTypeTab})
        : API_SPEC.OFFERS_ALL({cardId, page, size, offerTypeTab})
}

export default function MtgOffers({showCardName, cardId, objectType}) {

    const {isLoading, data, api, initialized} = useApi();
    const {items} = useSelector((state) => state.collectionReducer)
    const [tab, setTab] = React.useState(true);
    const {items: offers, page} = useSelector((state) => state.offersReducer)

    useEffect(() => {
        const offers_spec = offersSpec({cardId, page: 0, size: 25, offerTypeTab: tab})
        api(offers_spec);
    }, [cardId, items, initialized, tab]);

    const handleTabChange = (event, newValue) => {
        const offers_spec = offersSpec({cardId, page: 0, size: 25, offerTypeTab: tab})
        api(offers_spec);
        setTab(newValue);
    };

    const handleChangePage = (newPage, rowsPerPage) => {
        const offers_spec = offersSpec({cardId, page: newPage, size: rowsPerPage, offerTypeTab: tab})
        api(offers_spec);
    }

    const handleChangeRowsPerPage = (size) => {
        const offers_spec = offersSpec({cardId, page: 0, size: size, offerTypeTab: tab})
        api(offers_spec);
    }

    if (!offers) return

    return (
        <>
            <Box sx={{bgcolor: 'background.paper'}}>
                <Tabs
                    defaultValue={'Sell'}
                    value={tab}
                    onChange={handleTabChange}
                    variant="scrollable"
                    scrollButtons
                    allowScrollButtonsMobile
                    aria-label="offers"
                >
                    <Tab label={'Sellers'} value={true}/>
                    <Tab label={'Buyers'} value={false}/>
                </Tabs>
            </Box>
            <TabPanel value={tab} index={true}>
                <Offers showCardName={showCardName} offers={offers} offerType={true} page={page}
                        handleChangePage={handleChangePage}
                        handleChangeRowsPerPage={handleChangeRowsPerPage} objectType={objectType}/>
            </TabPanel>
            <TabPanel value={tab} index={false}>
                <Offers showCardName={showCardName} offers={offers} offerType={false} page={page}
                        handleChangePage={handleChangePage}
                        handleChangeRowsPerPage={handleChangeRowsPerPage} objectType={objectType}/>
            </TabPanel>
        </>
    )
}


function Offers({showCardName, offers, offerType, page, handleChangePage, handleChangeRowsPerPage, objectType}) {
    return (
        <PaginatedComponentInternalState size={offers.length} totalElements={page.totalElements}
                                         handleChangePage={handleChangePage}
                                         handleChangeRowsPerPage={handleChangeRowsPerPage}>

            <TableContainer marginTop={4} component={Paper}>
                <Table sx={{minWidth: 650}} aria-label="simple table">
                    <TableHead>
                        <TableRow>
                            {!!showCardName && <TableCell align="left">Card name</TableCell>}
                            <TableCell align="left">{offerType ? 'Seller' : 'Buyer'}</TableCell>
                            <TableCell align="left">Notes</TableCell>
                            <TableCell align="left">Condition</TableCell>
                            <TableCell align="center">Language</TableCell>
                            {objectType == 'card' && <TableCell align="center">Foil</TableCell>}
                            <TableCell align="right">Quantity</TableCell>
                            <TableCell align="right">Price</TableCell>
                            <TableCell align="right">Action</TableCell>
                        </TableRow>
                    </TableHead>
                    <TableBody>
                        {offers.map(o =>
                            <TableRow>
                                {!!showCardName && <TableCell align="left">
                                    <Box component={Link} to={`/${o.setCode}/${o.collectorNumber}/${o.cardName}`}>{o.cardName}</Box>
                                </TableCell>}
                                <TableCell align="left">
                                    <Box component={Link} to={`/user/${o.username}`}>{o.username}</Box>
                                </TableCell>
                                <TableCell align="left">{o.notes}</TableCell>
                                <TableCell align="left">{columns.condition.component(o.condition, false)}</TableCell>
                                <TableCell align="center">{o.language}</TableCell>
                                {objectType == 'card' &&
                                    <TableCell align="center">{columns.foil.component(o.foil, false)}</TableCell>}
                                <TableCell align="right">{o.quantity}</TableCell>
                                <TableCell
                                    align="right">{columns.price.component(o.price / 100, false)}</TableCell>
                                <TableCell align="right">
                                    <BuyEasyCart id={o.cardId} offerType={offerType} objectType={objectType}/>
                                </TableCell>
                            </TableRow>
                        )}
                    </TableBody>
                </Table>
            </TableContainer>
        </PaginatedComponentInternalState>
    )
}

function TabPanel(props) {
    const {children, value, index, ...other} = props;

    return (
        <div
            role="tabpanel"
            hidden={value !== index}
            id={`simple-tabpanel-${index}`}
            aria-labelledby={`simple-tab-${index}`}
            {...other}
        >
            {value === index && (
                <Box sx={{p: 3}}>
                    <Typography>{children}</Typography>
                </Box>
            )}
        </div>
    );
}

TabPanel.propTypes = {
    children: PropTypes.node,
    index: PropTypes.string.isRequired,
    value: PropTypes.string.isRequired,
};


